import React from 'react';
import ReactDOM from 'react-dom';
import { useDragState } from '../useDragState';
import { WidgetEditorContext } from '../WidgetEditorContext';
/**
 * Base component that should be used to create elements that initiate the drag action.
 * This component requires WidgetEditorContext to be available.
 */
export const DragBaseButton = (props) => {
    const editorContext = React.useContext(WidgetEditorContext);
    const [dragElement, dropElement, handlePointerDown, handlePointerUp, handlePointerMove] = useDragState(editorContext, props.createWidget);
    return (React.createElement(React.Fragment, null,
        props.buttonElement(handlePointerDown, handlePointerUp, handlePointerMove),
        dragElement && ReactDOM.createPortal(props.dragElement, dragElement),
        dropElement && ReactDOM.createPortal(props.dropElement, dropElement)));
};
